import {
  getInstantConfig,
  parseConfig,
  type InstantConfig,
  type InstantConfigResponse,
} from "./config";
import type { Matcher, GeoData } from "./matchers";
import type { WindowWithFandomContext } from "./bucketing";

export type WindowWithIcbm = Window & {
  instantConfig?: InstantConfigResponse;
} & WindowWithFandomContext;

export { defaultMatchers, deviceMatcher, regionMatcher } from "./matchers";
export type { InstantConfig, GeoData };
export * from "./variables";

export const loadInstantConfig = async (
  app: string,
  matchers: Matcher[],
  container: WindowWithIcbm,
): Promise<InstantConfig> => {
  const remoteConfig = await getInstantConfig(app, container);
  return parseConfig(remoteConfig, matchers, container);
};
